export default "__VITE_ASSET__Et0tyovU__"